import React, { useContext, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { MainMenu } from "../../../components/admin/shared";
import { Section, SidebarLayout } from "../../../components/shared";
import { MenuContext } from "../../../contexts/shared/menu";
import { CreatePerkModalProvider } from "../../../contexts/shared/create-perk-modal/provider";
import { FilterControls } from "../../../components/admin/perks/list/filter-controls";
import {
  default as PerksList
} from "../../../components/admin/perks/list";
import { admin } from "../../../graphql/admin";
import { client } from "../../../../graphql";
import { useQueryFilters, useControlledPagination } from "../../../helpers";
import { PaginationContext } from "../../../contexts/shared";

export const PerksIndex = () => {

  const { setMenuState } = useContext(MenuContext);
  const { loading, data, error, refetch } = useQuery(
    admin.queries.getPerks, { client }
  );
  const { applyFilters } = useQueryFilters({ refetch });
  const { currentPage, onPaginationChange } = useControlledPagination();

  useEffect(() => {
    setMenuState({
      openKeys: ["perks"]
    });
  }, []);

  const onFilter = (filter = {}) => {
    const { skip, pageSize: first } = onPaginationChange(1);
    applyFilters(prevFilters => ({
      ...prevFilters,
      ...filter,
      skip,
      first
    }));
  };

  const { registerRefetch } = useContext(PaginationContext);
  registerRefetch("perks", refetch);

  return (
    <CreatePerkModalProvider>
      <SidebarLayout menu={<MainMenu />}>
        <Section
          id="perks-section"
          title="Perks"
          spaced
          extra={<FilterControls onChange={onFilter} />}>
          <PerksList
            data={data}
            error={error}
            isLoading={loading}
            onChangePage={onPaginationChange}
            currentPage={currentPage} />
        </Section>
      </SidebarLayout>
    </CreatePerkModalProvider>
  );
};
